import {
  DataModelBuilder, SerializationContext, SerializedData,
} from '../../models/dto/dto.js';
import { VersionRange } from '../../models/core/version-range.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class ThirdPartyEventComponent extends Component {
  static readonly TYPE_ID: string = 'b52c651f66b24913b03270c9c73c286b';
  static readonly SCHEMA_VERSION: number = 2;

  constructor(
    public readonly url: string,
    public readonly freeEventUrl: string | null = null,
  ) {
    super();
  }

  get $removable(): boolean {
    return true;
  }

  get $typeId(): string {
    return ThirdPartyEventComponent.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.between(1, ThirdPartyEventComponent.SCHEMA_VERSION);
  }

  static fromMap(context: SerializationContext, map: SerializedData): ThirdPartyEventComponent {
    return new ThirdPartyEventComponent(
        MapUtils.getString(map, 'url'),
        MapUtils.getStringOrNull(map, 'freeEventUrl'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'url': this.url,
      'freeEventUrl': this.freeEventUrl,
    };
  }

  clone(): this {
    return new ThirdPartyEventComponent(
        this.url,
        this.freeEventUrl,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.url === this.url &&
      other.freeEventUrl === this.freeEventUrl;
  }
}

export class ThirdPartyEventComponentBuilder extends DataModelBuilder<ThirdPartyEventComponent> {
  build(context: SerializationContext, map: SerializedData): ThirdPartyEventComponent {
    return ThirdPartyEventComponent.fromMap(context, map);
  }

  override migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);
    if(versionRange.contains(ThirdPartyEventComponent.SCHEMA_VERSION)) {
      return map;
    }
    if(versionRange.isGreaterThan(ThirdPartyEventComponent.SCHEMA_VERSION)) {
      return null;
    }

    let version = versionRange.to;

    if(version < 2) {
      version = 2;
    }

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
